/**
 * عروضي — timing options, mapped 1:1 onto the EXISTING promo fields. Meanings
 * are the engine's, not redefined here (MEASURED, popuppush-app-v2
 * Utils.getNextVenueOverlayPromoEpochSeconds / MediaScreen.handleVenueOverlayPromoTick):
 *   show_duration_seconds  how long ONE design stays on screen
 *   interval_seconds       START-TO-START gap between appearances (automatic:
 *                          slots at start_time + N*interval inside the daily
 *                          window; manual: now + interval after each tick)
 *   manual_round_count     round cap, MANUAL mode only (automatic never caps)
 * One round = one full pass over every design.
 */
import { ar } from '../promosLogic';

export const DUR_OPTIONS = [5, 10, 15, 20, 30];
/**
 * 30 s is offered: backend validation is `interval_seconds min:1` and the player works in
 * seconds with no 60 s floor (slot grid + exact alarms), so no engine change is needed.
 */
export const EVERY_OPTIONS = [30, 60, 120, 300, 600, 1200];
export const ROUND_OPTIONS = [1, 2, 3, 4, 5];

/** Labels take the i18n `t` so English mode never shows Arabic. */
export const evLabel = (t, s) => (s < 60 ? t('promos.v2_ev_sec', { n: ar(s) }) : s === 60 ? t('promos.v2_ev_min1') : s === 120 ? t('promos.v2_ev_min2') : s % 60 === 0 ? t('promos.v2_ev_minN', { n: ar(s / 60) }) : t('promos.v2_ev_sec', { n: ar(s) }));
export const durLabel = (t, s) => t('promos.v2_dur_s', { n: ar(s) });
export const roundLabel = (t, n) => (n === 1 ? t('promos.v2_round1') : n === 2 ? t('promos.v2_round2') : t('promos.v2_roundN', { n: ar(n) }));

/**
 * An existing promo may carry a value outside the offered lists (e.g. 15-minute
 * interval, 6 rounds). Never drop it silently: it is appended as an extra chip so
 * opening and re-saving cannot change a calibrated value.
 */
export function withCurrent(options, current) {
  return current != null && !options.includes(current) ? [...options, current].sort((a, b) => a - b) : options;
}

/** An interval shorter than or equal to the duration would overlap itself: disabled in the UI. */
export const everyDisabled = (everySec, durSec) => everySec <= durSec;

export function timingSummary(t, { manual, whenLabel, designs, dur, every, rounds }) {
  const shows = designs * (manual ? rounds : 1);
  const mins = Math.ceil((shows * every) / 60);
  const head = manual ? t('promos.v2_sum_manual_head') : t('promos.v2_sum_auto_head', { when: whenLabel });
  const base = t('promos.v2_sum_base', { designs: ar(designs), dur: ar(dur), every: evLabel(t, every) });
  const tail = manual ? t('promos.v2_sum_manual_tail', { rounds: ar(rounds), shows: ar(shows), mins: ar(mins) }) : '';
  return `${head}${base}${tail}${t('promos.v2_sum_end')}`;
}

/** Arabic count nouns: 1 / 2 are words, 3+ take the plural with the number. `base` = i18n suffix (designs | screens). */
export const countLabel = (t, base, n) => (n === 1 ? t(`promos.v2_${base}_1`) : n === 2 ? t(`promos.v2_${base}_2`) : t(`promos.v2_${base}_n`, { n: ar(n) }));
